// Every full-page loader must offer a way out: after this delay the user gets a reload action.
export const SLOW_LOADING_TIMEOUT_MS = 20000;

export const SLOW_LOADING_MESSAGE = 'This is taking longer than expected.';
